/* eslint-disable react/jsx-no-undef */
import { FieldSet } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { BreedApi, BreedColorSaveDto } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { ERoutes } from "../../../../../ERoutes";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { ColorSelector } from "./ColorSelector";

export interface IBreedAllowedColorsPageProps {
  editMode: boolean;
  breedId: number;
}

export const BreedAllowedColorsPage: React.FunctionComponent<IBreedAllowedColorsPageProps> = ({
  editMode,
  breedId,
}) => {
  const api = useApiService(BreedApi);
  const { t } = useTl();
  const history = useHistory();

  const { data, loading, saving, saveItem } = useCrudApi<BreedColorSaveDto>(
    React.useMemo(
      () => ({
        getApiFn: (id = breedId) =>
          id > 0
            ? api.getBreedColors(id)
            : new BreedColorSaveDto({ breedId: id }).toJSON(),
        saveApiFn: (d: BreedColorSaveDto) => api.saveBreedColors(d),
        onSavedRoute: (d) => `${ERoutes.breeds}/${d.breedId}/linkedColors/edit`,
      }),
      [api, breedId]
    ),
    [breedId]
  );

  return (
    <FieldSet title={t(ETLCodes.Color)}>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        onCancel={() => history.push(ERoutes.breeds)}
        saving={saving}
      >
        <ColorSelector editMode={editMode} />
      </SmallFormGenerator>
    </FieldSet>
  );
};
